<template>
  <div>
    <v-list class="rounded-lg mt-2 grey lighten-3">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold subtitle-2">
            Plano atual
          </v-list-item-title>
          <v-list-item-title class="font-weight-bold title green--text">
            {{ meuPlano.descplano }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <btn-trocar-plano
            v-if="!meuPlano.solicitoucancelamento && podeAlterarIncluir"
          />
        </v-list-item-action>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold subtitle-2">
            Valores do plano
          </v-list-item-title>
          <v-list-item-title>
            <v-row>
              <v-col xl="auto" lg="auto" md="auto" cols="12">
                <p class="subtitle-2">Valor do plano</p>
                <p class="title font-weight-bold black--text">
                  {{ formatarMoeda(meuPlano.vlrtotalplano) }}
                </p>
              </v-col>
              <v-col xl="auto" lg="auto" md="auto" cols="12">
                <p class="subtitle-2">A Coasul paga</p>
                <p class="title font-weight-bold blue--text">
                  {{ formatarMoeda(meuPlano.vlrtotalcoasul) }}
                </p>
              </v-col>
              <v-col xl="auto" lg="auto" md="auto" cols="12">
                <p class="subtitle-2">Você paga</p>
                <p class="title font-weight-bold green--text">
                  {{ formatarMoeda(meuPlano.vlrtotalfunc) }}
                </p>
              </v-col>
            </v-row>
          </v-list-item-title>
          <v-list-item-subtitle
            class="mt-3 pb-1"
            v-if="!meuPlano.solicitoucancelamento && podeAlterarIncluir"
          >
            <btn-cancelar-plano />
          </v-list-item-subtitle>
          <v-row v-else dense class="mt-3">
            <v-col>
              <v-alert type="error" border="left" dense text
                >Solicitado cancelamento do plano</v-alert
              >
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-card flat class="rounded-lg mt-2 grey lighten-3">
      <v-card-title class="subtitle-2 font-weight-bold pb-1"
        >Dependentes do plano</v-card-title
      >
      <v-card-text>
        <v-card
          flat
          v-for="(dep, i) in getDependentesPossuemPlano()"
          :key="i"
          class="grey lighten-5 rounded-lg mt-2"
        >
          <v-card-title>
            <v-row>
              <v-col>
                <v-row>
                  <v-col
                    cols="12"
                    class="subtitle-1 font-weight-bold mb-0 pb-0"
                    >{{ dep.nome }}</v-col
                  >
                  <v-col cols="12" class="warning--text subtitle-2 mt-0 pt-0">{{
                    dep.parentesco
                  }}</v-col>
                </v-row>
              </v-col>
              <v-col class="d-flex justify-end">
                <v-alert
                  type="error"
                  text
                  class="subtitle-2"
                  dark
                  v-if="dep.solicitouremocao"
                  dense
                  >Remoção solicitada</v-alert
                >
                <btn-remover-dep-plano
                  v-else-if="
                    dep.codigo > 0 &&
                    !meuPlano.solicitoucancelamento &&
                    podeAlterarIncluir
                  "
                  :dependente="dep"
                />
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col>Valor do plano</v-col>
              <v-col class="font-weight-bold subtitle-1 d-flex justify-end">{{
                formatarMoeda(dep.vlrplano)
              }}</v-col>
            </v-row>
            <v-row dense>
              <v-col>A Coasul paga</v-col>
              <v-col
                class="font-weight-bold blue--text subtitle-1 d-flex justify-end"
                >{{ formatarMoeda(dep.vlrpagocoasul) }}</v-col
              >
            </v-row>
            <v-row dense>
              <v-col>O colaborador paga</v-col>
              <v-col
                class="font-weight-bold green--text subtitle-1 d-flex justify-end"
                >{{ formatarMoeda(dep.vlrpagofunc) }}</v-col
              >
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <btn-add-depen-plano
          v-if="!meuPlano.solicitoucancelamento && podeAlterarIncluir"
        />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { formatMoeda } from "@/global";
import { mapState } from "vuex";
import BtnTrocarPlano from "../buttons/BtnTrocarPlano.vue";
import BtnCancelarPlano from "../buttons/BtnCancelarPlano";
import BtnRemoverDepPlano from "../buttons/BtnRemoverDepPlano.vue";
import BtnAddDepenPlano from "../buttons/BtnAddDepenPlano.vue";

export default {
  components: {
    BtnTrocarPlano,
    BtnCancelarPlano,
    BtnRemoverDepPlano,
    BtnAddDepenPlano,
  },
  computed: mapState("planoSaude", ["meuPlano", "podeAlterarIncluir"]),
  methods: {
    formatarMoeda(value) {
      return formatMoeda(value);
    },
    getDependentesPossuemPlano() {
      return this.meuPlano.dependentes.filter((d) => d.possuiplano);
    },
  },
};
</script>

<style></style>
